























































































import { get } from 'js-cookie';
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import Ajax from '../../lib/ajax'
import topPageResult from '@/store/entities/page-result';
@Component
export default class Notice extends AbpBase{
    noticeSpinShow:boolean=true;
  
 state= {
        num:0,
        ordercount:0,
        iscl:false, //关闭订单提醒
        isucl:true,
        ordertype:0
    
  }
   
  get userName(){
   
          return this.$store.state.session.user?this.$store.state.session.user.name:''
          
        }
    get noticeList():Array<any>{
        return this.$store.state.app.noticeList;
    }
    get unReadCount(){
        return this.noticeList.filter(n=>n.read==false).length
    }
    get noticeArray(){
        return this.noticeList.filter(n=>n.read==false&&n.type===0)
    }
    get noticeCount(){
        return this.noticeList.filter(n=>n.read==false&&n.type===0).length
    }
    get messageArray(){
        return this.noticeList.filter(n=>n.read==false&&n.type===1)
    }
    get messageCount(){
        return this.noticeList.filter(n=>n.read==false&&n.type===1).length
    }
    get taskArray(){
        return this.noticeList.filter(n=>n.read==false&&n.type===2)
    }
    get taskCount(){
        return this.noticeList.filter(n=>n.read==false&&n.type===2).length
    }
    get noticeLabel(){
        let name=this.L('Notice');
        if(this.noticeCount>0){
            return `${name}(${this.noticeCount})`
        }else{
            return name
        }
    }
    get messageLabel(){
        let name=this.L('Message');
        if(this.messageCount>0){
            return `${name}(${this.messageCount})`
        }else{
            return name
        }
    }
    get taskLabel(){
        let name=this.L('Task')
        if(this.taskCount>0){
            return `${name}(${this.taskCount})`
        }else{
            return name
        }
    }
    isordclose(){
             this.state.isucl=false;
             this.state.iscl=false;

    }
    getNotices(){
        setTimeout(()=>{
            this.noticeSpinShow=false;
        },2000)
    }
    created() {
  this.$Notice.config({
     top: 50,
    
});

     var th=this;
    
      let uid=abp.session.userId;
      if(uid==4){
        th.state.ordertype=23;

      }else{
         th.state.ordertype=0;

      }
      /*
      
      console.log(uid)
            

        if(uid>0){
           

      Ajax. get('/api/services/app/User/Get?Id='+uid)
      . then(function (response) {
        let rlst=  response.data.result.roleNames ;
        for(var i=0;i<rlst.length;i++){
            console.log(rlst[i]);
               if(rlst[i]=="ADMIN"){
                        th.state.ordertype=0;
                        break;

               }else if(rlst[i]=="DISPOSE"){

                     th.state.ordertype=23;
                        break;
               }
             
        }
                 
      window.setInterval(() => {
        setTimeout(th.getOrderList, 0)
        }, 3000)
           

  });

 } */
 /////////////
    window.setInterval(() => {
        setTimeout(th.getOrderList, 0)
        }, 15000)
 
  //原3秒现在改30秒
 // window.setInterval(th.getOrderList, 30000)
   
      //this.getOrderList();
        

     
    

    }


    getOrderList(){
      //  this.$Notice.destroy()
    
      console.log("getOrderList执行了")
        var th =this;
        if(th.state.isucl){
        Ajax.get('/api/services/app/OrderManagement/GetOrderStateCount?status=-1&type='+this.state.ordertype). then(function (response) {
        let count=  response.data.result.count
        th.state.ordercount=count;
        if(count>0){
            th.state.iscl=true;
        }else{
            th.state.iscl=false;
        }
        
  });
  
        
        }


   
      
  
        
 
/*

       this.$Notice.open({
                    title: '订单提醒',
                    desc: '您当前还有'+count+'条订单未处理',
                    duration: 0
      });*/
    }
}
